// extracted by mini-css-extract-plugin
export default {"cls1":"Bb3ZBOZUaI90wuaLJeCA","cls2":"PphOV9hwmDGES3JWDHd1 Bb3ZBOZUaI90wuaLJeCA"};